import { createFileRoute } from "@tanstack/react-router"
import Home from "@/routes/-pages/Home"

export const Route = createFileRoute("/")({
  component: Home,
})
